/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of drugs (patients) to display or load drugs */


(function () {
  'use strict';
  angular.module('vcdrug')
    .component('druglist', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      template: `
        <hr class="spacer-bottom spacer-top">
        <h4>Medikationsliste</h4>
          <div class="alert alert-info" ng-show="vm.ready === 'loading'">
            <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...
          </div>
          <div class="alert alert-info" ng-show="vm.totalcount === 0">
            <i class="fa fa-info-circle"></i> Keine Medikationsdaten gefunden!
          </div>
        <div ng-hide="vm.totalcount === 0">
          <span class="btn btn-success" ng-click="vm.prescriptionPrint(vm.patientid)">
            <i class="fa fa-print" ng-hide="vm.printstarted"></i>
            <i class="fa fa-spinner fa-spin" ng-show="vm.printstarted"></i> Rezept(e) drucken</span>
          <a class="btn btn-primary" ng-show="vm.pdfbinurl"  href="{{vm.pdfbinurl}}" target="_blank">
            <i class="fa fa-eye"></i> Neuerstelltes Rezept ansehen
          </a>
          <a class="btn btn-info" href="{{vm.prescriptionPreview(vm.patientid)}}" target="_blank">
            <i class="fa fa-eye"></i> Rezept(e) Vorschau
          </a>
          <a class="btn btn-info" href="{{vm.lastfileUrl}}" ng-show="vm.lastfileUrl" target="_blank">
            <i class="fa fa-eye"></i> {{vm.lastfileName}}
          </a>
        </div>
        <div><input type="checkbox" ng-model="vm.patdrugs.printdate" ng-change="vm.save()"> Datum auf Rezept</div>
        <table class="table table-striped"  ng-hide="vm.totalcount === 0">
          <thead>
          <tr>
            <th>Drucken <sprhelp tip="Rezept f&uuml;r Medikament drucken" descref="vm.sprprint"></sprhelp></th>
            <th>Aktuell <sprhelp tip="Dauermedikation oder aktuelle Anla&szlig;medikation"></sprhelp></th>
            <th>Name</th>
            <th>Einnahme</th>
            <th>Pkg Anzahl</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="drug in vm.patdrugs.drugs | orderBy: ['-active', 'foreign']" ng-class="{druginactive: !drug.active}">
            <td><input type="checkbox" ng-model="drug.print" ng-show="drug.foreign === false && drug.active === true" ng-change="vm.save()"></td>
            <td><input type="checkbox" ng-model="drug.active" disabled></td>
            <td>
                <span class="label label-{{drug.color}}" ng-show="drug.active === true">{{drug.name}}</span>
                <span ng-show="drug.active === false" style="color: #999999">{{drug.name}}</span>
                <span ng-show="drug.foreign === true"> (Fremdverordnung)</span>
                <span ng-show="drug.converted === true"> (Konvertierte&nbsp;Fremdverordnung)</span>
            </td>
            <td ng-bind="drug.amount" ng-show="drug.foreign === false || drug.active === false"></td>
            <td ng-show="drug.foreign === true && drug.active === true">
            <input class="form-control" ng-model="drug.amount" ng-blur="vm.editForeign(drug, oldamount)" ng-focus="oldamount = drug.amount">                              
            </td>
            <td ng-bind="drug.op"></td>
            <td>
              <button class="btn btn-primary"
                      ng-show="drug.foreign === false && drug.active === true"
                      ng-click="vm.editDrug(drug)">
                 <i class="fa fa-edit" uib-tooltip="Editieren"></i>
              </button>
              <sprhelp ng-show="drug.foreign === false && drug.active === true"
                       tip="Rezept ab&auml;ndern" descref="vm.spredit"></sprhelp>
              <button class="btn btn-success"
                      ng-show="drug.foreign === false && drug.active === false"
                      ng-click="vm.reactivateDrug(drug)">
                 <i class="fa fa-repeat" uib-tooltip="Wieder verschreiben"></i>
              </button>
              <sprhelp ng-show="drug.foreign === false && drug.active === false"
                       tip="Wieder verschreiben" descref="vm.spractivate"></sprhelp>
              <button class="btn btn-warning"
                      ng-show="drug.foreign === true && drug.active === true"
                      ng-click="vm.convertDrug(drug)">
                 <i class="fa fa-retweet" uib-tooltip="Fremdverordnung in Eigenverordnung umwandeln"></i>
              </button>
              <sprhelp ng-show="drug.foreign === true && drug.active === true"
                       tip="Fremdverordnung in Eigenverordnung umwandeln" descref="vm.sprconvert"></sprhelp>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Drug', 'vertxEventBusService', '$uibModal', 'PrintHelper', 'Document', '$timeout',
        function ($log, $http, Rlog, Drug, vertxEventBusService, $uibModal, PrintHelper, Document, $timeout) {
          let vm = this;
          // vm.editDrug = DrugHelper.editDrug;
          vm.editDrug = editDrug;
          vm.save = save;
          vm.editForeign = editForeign;
          vm.convertDrug = convertDrug;
          vm.reactivateDrug = reactivateDrug;
          vm.checkSignatureUpdate = checkSignatureUpdate;
          vm.prescriptionPrint = prescriptionPrint;
          vm.prescriptionPreview = PrintHelper.prescriptionPreviewUrl;


          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              getPatdrugs();
            }
          };

          function getPatdrugs() {
            Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
              vm.patdrugs = drugs[0];
              if (angular.isUndefined(vm.patdrugs.printdate)) {
                vm.patdrugs.printdate = true;
              }
              $log.info('patdrugs search result: ', drugs);
              calcdrugs(vm.patdrugs);
              vm.ready = true;
            });
            lastprint(vm.patientid);
          }


          function convertDrug(drug) {
            let tmpdrug = angular.copy(drug);
            tmpdrug.patdrugsnr = getPatdrugsnr();
            tmpdrug.startDate = moment().toISOString();
            tmpdrug.endate = moment().add(14, 'days').toISOString();
            tmpdrug.print = true;
            tmpdrug.op = 'OP I';
            tmpdrug.foreign = false;
            tmpdrug.color = 'primary';
            tmpdrug.permanent = false;
            tmpdrug.converted = true;
            $log.debug('converted drug: ', tmpdrug);
            vm.patdrugs.drugs.push(tmpdrug);
            save();
          }

          function reactivateDrug(drug) {
            // reactivate by copying record with a new startdate
            let tmpdrug = angular.copy(drug);
            tmpdrug.startDate = moment().toISOString();
            if (!drug.permanent) {
              tmpdrug.endate = moment().add(14, 'days').toISOString();
            }
            tmpdrug.print = true;
            tmpdrug.active = true;
            vm.patdrugs.drugs.push(tmpdrug);
            save();
          }

          function save() {
            if (vm.patdrugs.$hasPendingActions()) {
              vm.patdrugs.cancel();
            }
            vm.patdrugs.$save();
          }

          function getPatdrugsnr() {
            return moment().unix() + '_' + Math.floor(Math.random() * 1000 + 1);
          }


          function editDrug(ldrug) {
            let dialog = $uibModal.open({
              template: `
                   <div class="modalspacer">
                        <drugeditor drug="drugeCtrl.drug" parentsave="drugeCtrl.childsave(drug)" oncancel="drugeCtrl.cancel()"></drugeditor>
                   </div>
              `,
              controllerAs: 'drugeCtrl',
              controller: ['drug', 'drugs', function (sdrug, sdrugs) {
                let lvm = this;
                lvm.drug = sdrug;
                lvm.childsave = childsave;
                lvm.cancel = cancel;


                function childsave(drug) {
                  // vm.drug = angular.copy(drug);
                  // the abouve code threw an restmod error, despite actually saving
                  // the below variant does not raise an error
                  if (ldrug.amount !== drug.amount) {
                    let tmpdrug = angular.copy(drug);
                    tmpdrug.startDate = moment().toISOString();
                    if (!tmpdrug.permanent) {
                      tmpdrug.endDate = moment().add(14, 'days').toISOString();
                    }
                    if (tmpdrug.permanent && tmpdrug.endDate) {
                      delete tmpdrug.endDate;
                    }

                    ldrug.active = false;
                    ldrug.print = false;
                    ldrug.endDate = moment().toISOString();
                    sdrugs.push(tmpdrug);
                  } else {
                    // ldrug = angular.copy(drug);
                    for (let key in drug) {
                      if (drug.hasOwnProperty(key)) {
                        ldrug[key] = drug[key];
                      }
                    }
                  }
                  save();
                  dialog.close();
                }

                function cancel() {
                  dialog.close();
                }

              }],
              resolve: {
                drug: function () {
                  return ldrug;
                },
                drugs: function () {
                  return vm.patdrugs.drugs;
                }
              },
              size: 'lg'
            });
            return dialog;
          }

          function editForeign(drug, oldamount) {
            if (drug.amount !== oldamount && drug.amount.length > 0) {
              let newfdrug = angular.copy(drug);
              drug.amount = oldamount;
              let now = moment().toISOString();
              newfdrug.startDate = now;
              drug.endDate = now;
              drug.active = false;
              vm.patdrugs.drugs.push(newfdrug);
              vm.patdrugs.$save();
            } else {
              drug.amount = oldamount;
            }
          }

          function calcdrugs(drugs) {
            vm.ready = 'done';
            vm.activecount = 0;
            vm.totalcount = 0;
            if (angular.isDefined(drugs) && angular.isDefined(drugs.drugs)) {
              vm.totalcount = drugs.drugs.length;
              let saveneeded = 0;
              for (let i = 0; i < drugs.drugs.length; i++) {
                // deactivate expired "once-off" drugs
                if (drugs.drugs[i] && drugs.drugs[i].active && drugs.drugs[i].end && drugs.drugs[i].end < moment().toISOString()) {
                  drugs.drugs[i].active = false;
                  drugs.drugs[i].print = false;
                  saveneeded++;
                }
                if (drugs.drugs[i] && drugs.drugs[i].active) {
                  vm.activecount++;
                }
                if (saveneeded > 0) {
                  save();
                }
              }
            } else {
              vm.activecount = 0;
              vm.totalcount = 0;
            }

          }

          function prescriptionPrint(patientid) {
            vm.printstarted = true;
            if (vm.patdrugs.printdate === true) {
              vm.patdrugs.date = moment().format('ll');
              // $log.debug('[][][] new date: ', vm.patdrugs.date);
            } else {
              vm.patdrugs.date = '';
              // $log.debug('no date: ', vm.patdrugs.date);
            }
            if (vm.patdrugs.$hasPendingActions()) {
              vm.patdrugs.cancel();
              $log.debug('[VCDRUG][DRUGLIST][PRESCRIPTIONPRINT] cancelling pending actions');
              // some delay between cancel and retry is needed
              $timeout(reallyPrint(patientid), 1500);
            } else {
              reallyPrint(patientid);
            }
          }

          function reallyPrint(patientid) {
            vm.patdrugs.$save().$then(function (patdrugs) {
                $log.debug('[VCDRUG][DRUGLIST][prescriptionPrint] saved before print succeeded: ', patdrugs);
                PrintHelper.prescriptionPrint(patientid).then(function (pdfbin) {
                  $log.debug('[VCDRUG][DRUGLIST][prescriptionPrint] print succeeded: ', pdfbin);
                  vm.printstarted = false;
                  vm.pdfbinurl = '/routes/pdfreader/' + pdfbin.data.docid;
                }, function (err) {
                  $log.error('[VCDRUG][DRUGLIST][prescriptionPrint] prescriptionPrint failed', err);
                });
              },

              function (err) {
                // TODO: super weird error - the call is ok, but the error handler is called WTF! see dms.scan.filebrowser for similar problem
                $log.error('[VCDRUG][DRUGLIST][prescriptionPrint] save before print failed - or not: ', err);
                // ignore error and try anyway
                PrintHelper.prescriptionPrint(patientid).then(function (pdfbin) {
                  vm.printstarted = false;
                  vm.pdfbinurl = '/routes/pdfreader/' + pdfbin.data.docid;
                }, function (printerr) {
                  $log.error('[VCDRUG][DRUGLIST][prescriptionPrint] prescriptionPrint failed', printerr);
                  Rlog.error('vcdrug.druglist', 'prescriptionPrint', 'Printing of prescription pdf failed for patient: ', {patientid: patientid});
                });
              });
          }

          function lastprint(patientid) {
            Document.$getLast(patientid, 'prescription').$then(function (lastdocarray) {
              $log.debug(' ###### lastdocarr: ', lastdocarray);
              if (lastdocarray.length === 1) {
                let lastdoc = lastdocarray[0];
                vm.lastfileUrl = '/routes/pdfreader/' + lastdoc._id;
                vm.lastfileName = 'Letztes Rezept vom ' + lastdoc.fdate + ', ' + lastdoc.ftime;
              }
            }, function (err) {
              $log.error('prescription lookup failed for patientid: ', patientid, err);
            });
          }

          function checkSignatureUpdate(drug) {
            $log.debug('**************** checkSignatureUpdate called for: ', drug);
            if (angular.isString(drug.newamount) && drug.newamount.length > 0) {
              if (drug.newamount !== drug.amount) {
                // copy drug
                let tmpdrug = angular.copy(drug);
                // create new drug
                tmpdrug.startDate = moment().toISOString();
                tmpdrug.amount = tmpdrug.newamount;
                delete tmpdrug.newamount;
                // deactive old drug
                drug.active = false;
                drug.endDate = moment().toISOString();
                $log.debug('drug: ', drug);
                $log.debug('tmpdrug: ', tmpdrug);
                vm.patient.drugs.push(tmpdrug);
                $log.debug('vm.patdrugs after: ', vm.patdrugs.drugs);
                save();
              } else {
                drug.newamount = '';
              }
            }
          }

          vm.sprconvert = `Wandeln Sie die Fremdverordnung wir in eine befristete Eigenverordnung um damit Sie
            ein Rezept f&uuml; eine Fremdverordnung austellen k&ouml;nnen. Die Fremdverodnung bleibt erhalten,
            die resultierende Eigenverordnung wird nach 14 Tagen automatisch deaktiviert.`;

          vm.spractivate = `Reaktivieren sie bereits fr&uuml;her verschriebene Anla&szlig;medikation oder
            abgesetzte Dauermedikation. Die zuletzt verwendendeten Rezepteinstellungen bleiben erhalten.`;
          vm.spredit = `&Auml;ndern Sie Einnahmeanweisung/Signatur, Packungsanzahl, Rezeptvermerk und Dauermedikationststatus.
            Beim &Auml;nderungen an der Einnahmeanweisung/Signatur wird das Medikament abgesetzt und
            mit neuer Einnahmeanweisung neuverschrieben, damit Sie &Uuml;berblick
            &uuml;ber Dosis&auml;nderungen behalten.`;
          vm.sprprint = `Markierte Medikamente werden als Rezept(e) gedruckt. Die Aufteilung erfolgt automatisch.
            Suchtgiftrezepte und bewilligungspflichtige werden gesondert ausgefolgt.`;

          const patdrugsUpdateHandler = function (message) {
            // $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            // if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
            if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id)) {
              vm.patdrugs.$refresh().$then(function () {
                $log.debug('[vcdrug][druglist] refreshed patdrugs for druglist: ', vm.patdrugsid);
                calcdrugs(vm.patdrugs);
                vm.ready = true;
              }, function (error) {
                $log.debug('[vcdrug][druglist] refreshing patdrugs for druglist failed: ', error, vm.patdrugsid);
              });
            } else {
              getPatdrugs();
              $log.debug('[vcdrug][druglist] refreshed patdrugs for druglist, inital fetch for an undfined patdrug ');
            }
          };

          vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
